import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "planPurchase",
    serviceName: "auth",
    query: gql`
      query planPurchase(
        $ids: [String]
        $for_lab_ids: [String]
        $for_unit_ids: [String]
        $for_doctor_ids: [String]
        $plan_id: String
        $user_id: String
        $purchase_time: String
        $validity_months: String
        $expire_at: String
        $payment_type_id: String
        $payment_status_id: String
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        planPurchase(
          ids: $ids
          for_lab_ids: $for_lab_ids
          for_unit_ids: $for_unit_ids
          for_doctor_ids: $for_doctor_ids
          plan_id: $plan_id
          user_id: $user_id
          purchase_time: $purchase_time
          validity_months: $validity_months
          expire_at: $expire_at
          payment_type_id: $payment_type_id
          payment_status_id: $payment_status_id
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          data {
            id
            created_at
            updated_at
            details
            amount # مبلغ طرح
            purchase_time # زمان خرید طرح
            validity_months # تعداد ماه اعتبار
            expire_at # انقضای طرح در
            lab_quantity # تعداد لابراتوار در طرح خریداری شده
            unit_quantity # تعداد کلینیک در طرح خریداری شده
            doctor_quantity # تعداد پزشک در طرح خریداری شده
            user {
              # خریدار
              id
            }
            plan {
              id
              title
              related_to
            }
            lab {
              # لابراتوار خریدار
              id
            }
            unit {
              # کلینیک خریدار
              id
            }
            doctor {
              # پزشک خریدار
              id
            }
            payment_type {
              id
            }
            payment_status {
              id
            }
          }
          total
          last_page
        }
      }
    `,
  },
};

export default schema;
